import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getUserInfo } from "../actions/inquires";

import { errorOpen } from "../actions/step";

import { appointementUser } from "../actions/appointement";

import SelectMenu from "./components/SelectMenu";
import InputForm from "./components/InputForm";
import BooleanRadio from "./components/BooleanRadio";
import { CSSTransition, transit } from 'react-css-transition';

import "react-select/dist/react-select.css";

const unactiveBtnStyle = {
  borderColor: "#f4bca4",
  color:"#f4bca4",
  background: "#fff",
  cursor: "default"
};
const active = {
  opacity: 0.5
};


class ClassInformation extends Component {
  constructor(props) {
    super(props);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputClick = this.handleInputClick.bind(this);
    this.generateOptions = this.generateOptions.bind(this);
    this.state = {
      "1IsActive": null,
      "2IsActive": null,
      "3IsActive": null,
      "4IsActive": null,
      "5IsActive": null,
      "6IsActive": null,
      "7IsActive": null,
      "8IsActive": null,
    };
  }

  handleKeyPress = (e) => {
    this.handleInputClick(e);
  }

  handleSelectChange(event, name) {
    this.props.getUserInfo(event.value, name);
  }
  handleInputChange(value, name) {
    //this.handleInputClick(this.state);
    this.props.getUserInfo(value, name);
  }
  handleInputClick(erz){
    console.log(erz);
    switch(erz) {
      case "1IsActive":
        this.setState({'1IsActive':true})
      break;
      case "2IsActive":
        this.setState({'2IsActive':true})
      break;
      case "3IsActive":
        this.setState({'3IsActive':true})
      break;
      case "4IsActive":
        this.setState({'4IsActive':true})
      break;
      case "5IsActive":
        this.setState({'5IsActive':true})
      break;
      case "6IsActive":
        this.setState({'6IsActive':true})
      break;
      case "7IsActive":
        this.setState({'7IsActive':true})
      break;
      case "8IsActive":
        this.setState({'8IsActive':true})
      break;
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    var userInfo = this.props.restIntel.intel.user;
    for (let index = 0; index < userInfo.length; index++) {
      let ElmId = userInfo[index].promptDisplay;
      userInfo[index].value = this.props.inquires.user[ElmId];
    }
    var regexEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var regTel = /^0\d(\s|-)?(\d{2}(\s|-)?){4}$/;

    var errorMsg = [];
    if(!regexEmail.test(this.props.inquires.user.email)){
      errorMsg.push("L'email " + this.props.inquires.user.email + " est invalide.\n");
    }
    if(!regTel.test(this.props.inquires.user.phone_number)){
      errorMsg.push("Le numéro de téléphone doit commencer par 0.\n");
    }
    if(this.props.inquires.user.phone_number.length!=10){
      errorMsg.push("Le numéro de téléphone doit être egal à 10 chiffres.\n");
    }

    //this.props.inquires.user.adress = ;

    // if(this.props.inquires.user.address===undefined) {
    //   errorMsg.push("L'adresse doit être renseignée.\n");
    // }
    if(errorMsg.length===0){
        this.props.appointementUser(userInfo);
        //TRACKING
        var values = {};
        var type = this.props.inquires.home.type;
        values.eventName = "personal-data";
        if(this.props.inquires.home.type=="achat") {
          this.props.inquires[type]['purchaseTime']['leadName']===undefined ? values['purchase-intent'] = "Less than a month" : values['purchase-intent'] = this.props.inquires[type]['purchaseTime']['leadName'];
          values['financing'] = this.props.inquires[type]['financing'];
          values['seatCustomer'] = this.props.inquires[type]['customerSeat'];
          values['licenseRegistration'] = "";
        }
        this.props.inquires[type]['test']=="non" || this.props.inquires[type]['test']==null ? values['testDrive'] = "non" : values['testDrive'] = "oui";
        this.props.inquires[type]['appointment']==null ? values['prefence'] = "" : values['prefence'] = this.props.inquires[type]['appointment'];
        var iframeData = ["setData", values];
        console.log('iframeData :'+ iframeData );
        window.top.postMessage(iframeData , '*');
        console.log(values);
    } else {
      const errmsg = errorMsg.map( e => {
        return (<span>{e}<br/></span>);
      })
      this.props.errorOpen('Message d\'erreur', errmsg);
    }

  }
  generateOptions(data) {
    var options = data.split(",");
    return options.map(i => {
      return { value: i, label: i };
    });
  }
  componentDidMount(){
    var iframeData = ['setVirtualPage', 'rdv-en-ligne/personnel_data'];
    console.log('iframeData :'+ iframeData );
    window.top.postMessage(iframeData , '*');
  }
  render() {
    var form = this.props.restIntel.intel.user;
    var formValidate = true;

    var formRender = form.map(i => {
      var erz= `${i.id}IsActive`;
      if ( (this.props.inquires.user[i.promptDisplay] === undefined || this.props.inquires.user[i.promptDisplay].length < 2) && i.labelDisplay!=="Adresse" ) {
        formValidate = false;
      }
      return (
        <div
          className={this.state[erz] != true && i.promptDisplay !== "optin" && i.labelDisplay!=="address" ? "pageFormSub pageFormSubInformation"  : "active pageFormSub pageFormSubInformation" }
          key={"pageFormSub_" + i.id} onClick={() => this.handleInputClick(erz)} onKeyPress={(e) => this.handleKeyPress(erz)}
        >
          <div
            className={this.state[erz] != true && i.promptDisplay !== "optin" && i.labelDisplay!=="address" ? "pageFormSubTitle fontBold colorBlack"  : "active pageFormSubTitle fontBold colorBlack" } style={this.state.isActive === i || this.state.isActive === null  ? null : active} key={"pageFormSubTitle_" + i.id}
          >
           {i.promptDisplay!=="address" ? i.labelDisplay + "*" : null }
          </div>
          {i.controlType !== "list" && i.controlType !== "multiSelectList" && i.promptDisplay!=="address"  ? (
            <InputForm
              name={i.promptDisplay}
              ref={() => this.handleInputClick(erz)}
              autoComplete="off"
              maxLength={i.promptDisplay !== "phone_number" ? i.maxChars : 10}
              placeholder={i.labelDisplay}
              value={this.props.inquires.user[i.promptDisplay]}
              onChange={this.handleInputChange}
              key={"InputForm_" + i.id}
            />
          ) : i.promptDisplay !== "optin" && i.promptDisplay!=="address" ? (
            <SelectMenu
              index={i.promptDisplay}
              placeholder="Selectionnez"
              searchable={false}
              clearable={false}
              options={this.generateOptions(i.defaultValue)}
              value={this.props.inquires.user[i.promptDisplay]}
              onChange={this.handleSelectChange}
              key={"SelectMenu_" + i.id}
            />
          ) : i.promptDisplay!="address" ? (
            <div className="pageFormSub end">
              <BooleanRadio
                  name={i.promptDisplay}
                  txt="Oui"
                  state={this.props.inquires.user[i.promptDisplay]}
                  value="oui"
                  onClick={this.handleInputChange}
                />
              <BooleanRadio
                  name={i.promptDisplay}
                  txt="Non"
                  state={this.props.inquires.user[i.promptDisplay]}
                  value="non"
                  onClick={this.handleInputChange}
                />
            </div>
          ) : null }
        </div>
      );
    });
    return (
      <div className="moduleMainBodyIntel" >
        <form onSubmit={this.handleSubmit} className="formPage">
          <div className="pageFormTitle fontBold colorBlack">
            Vos informations
          </div>
          {formRender}
          <div className="pageCtaContent infopers">
            <div className="pageMention fontBook colorGrey3">
              *Champs obligatoires
            </div>
            <button
              className="pageCta fontMedium colorBlack"
              disabled={!formValidate}
              style={formValidate ? null : unactiveBtnStyle}
            >
              Continuer
            </button>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getUserInfo,
      appointementUser,
      errorOpen
    },
    dispatch
  );

export const PageInformation = connect(
  mapStateToProps,
  mapDispatchToProps
)(ClassInformation);



// WEBPACK FOOTER //
// ./src/containers/PageInformation.js